import React from 'react';

import SettingsForm from './SettingsForm';

const Settings = () => <SettingsForm />;

export default Settings;
